import type { ArCustomerRisk, ArRiskLevel } from '../../types/arDunning';
import { RISK_LABEL, riskDotClass, riskPillClass, formatDelayDays } from '../../utils/arDunningFormat';

/**
 * Payment-behaviour risk indicator. `variant="dot"` renders a compact coloured dot with
 * a native tooltip (used inline in list rows); `variant="pill"` renders a labelled pill
 * (used in the detail panel / risk lists). The tooltip surfaces the score reasons.
 */
export function RiskBadge({ risk, variant = 'dot' }: { risk: ArCustomerRisk | undefined; variant?: 'dot' | 'pill' }) {
    const level: ArRiskLevel = risk?.RiskLevel ?? 'none';
    const title = risk
        ? `${RISK_LABEL[level]} (score ${risk.RiskScore})`
          + (risk.RiskReasons.length ? ` — ${risk.RiskReasons.join('; ')}` : '')
          + (risk.AvgDelayDays != null ? ` · avg ${formatDelayDays(risk.AvgDelayDays)} over ${risk.PaidInvoiceCount} paid` : '')
        : 'No payment-behaviour data';

    if (variant === 'pill') {
        return (
            <span title={title} className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${riskPillClass(level)}`}>
                <span className={`h-2 w-2 rounded-full ${riskDotClass(level)}`} />
                {RISK_LABEL[level]}
            </span>
        );
    }
    return <span title={title} className={`inline-block h-2.5 w-2.5 rounded-full ${riskDotClass(level)}`} aria-label={RISK_LABEL[level]} />;
}
